import { CheckboxList } from '@zola/zola-ui/src/components/Form/CheckboxList';

import { FieldArray } from 'react-final-form-arrays';

import { GeneralQuestions } from './GeneralQuestions';

const ETHICAL_AREAS = [
  {
    value: 'florist-ethical-areas-fair-trade-sourcing',
    label: 'Fairtrade sourcing',
  },
  {
    value: 'florist-ethical-areas-support-local-farms',
    label: 'Local sourcing',
  },
  {
    value: 'florist-ethical-areas-seasonal-sourcing',
    label: 'Seasonal sourcing',
  },
  {
    value: 'florist-ethical-areas-chemical-free-sourcing',
    label: 'Chemical-free sourcing',
  },
  {
    value: 'florist-ethical-areas-green-breakdown',
    label: 'Biodegradable design',
  },
  {
    value: 'florist-ethical-areas-reusable-recyclable-materials',
    label: 'Recyclable & reusable design',
  },
  {
    value: 'florist-ethical-areas-foam-free',
    label: 'Foam-free design',
  },
];

export const FloristQuestions = (): JSX.Element => (
  <div>
    <GeneralQuestions />
    <fieldset className="mt-primary">
      <legend>Ethical Areas</legend>
      <FieldArray options={ETHICAL_AREAS} name="optionFacetKeys" id="ethicalAreas">
        {({ fields, meta }) => <CheckboxList fields={fields} meta={meta} options={ETHICAL_AREAS} />}
      </FieldArray>
    </fieldset>
  </div>
);
